const apiUrl = process.env.REACT_APP_API_URL;

export const getRoles = async() => {
    const token = sessionStorage.getItem('token');
    const url =  `${apiUrl}/api/generalQueries/getRoles`;       
    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return []
    }
}


export const getStatuses = async() => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/generalQueries/getStatuses`;       
    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return []
    }
}
